import React from "react"
import { FormattedMessage } from "react-intl"

export const getReorderProductsModalHeaders = () => {
    return [
        <FormattedMessage
            key="inventory.modal.reorder_products_modal_supplier.supplier"
            id="inventory.modal.reorder_products_modal_supplier.supplier"
            defaultMessage="Supplier"
        />,
        <FormattedMessage
            key="inventory.modal.reorder_products_modal_supplier.products"
            id="inventory.modal.reorder_products_modal_supplier.products"
            defaultMessage="Products due"
        />,
    ]
}  


// WEBPACK FOOTER //
// ./src/utils/listing/utils.tsx